// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MuiBox-root{
    /*height: auto !important;*/
    /*width: auto !important;*/
}
.link{
    text-decoration: underline;
    color: rgb(0, 106, 198);
    cursor: pointer;
}

.divUploadLogo{
    right: 115px !important;
    top: 130px !important;
}

.css-7ldjcq-MuiGrid-root>.MuiGrid-item{
    padding-left: 0px  !important; 
}

.divNameLogo{
    right: 190px !important;
    top: 140px  !important;
}`, "",{"version":3,"sources":["webpack://./src/adminCore/insuranceType/style.css"],"names":[],"mappings":"AAAA;IACI,2BAA2B;IAC3B,0BAA0B;AAC9B;AACA;IACI,0BAA0B;IAC1B,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,uBAAuB;IACvB,qBAAqB;AACzB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,uBAAuB;IACvB,sBAAsB;AAC1B","sourcesContent":[".MuiBox-root{\r\n    /*height: auto !important;*/\r\n    /*width: auto !important;*/\r\n}\r\n.link{\r\n    text-decoration: underline;\r\n    color: rgb(0, 106, 198);\r\n    cursor: pointer;\r\n}\r\n\r\n.divUploadLogo{\r\n    right: 115px !important;\r\n    top: 130px !important;\r\n}\r\n\r\n.css-7ldjcq-MuiGrid-root>.MuiGrid-item{\r\n    padding-left: 0px  !important; \r\n}\r\n\r\n.divNameLogo{\r\n    right: 190px !important;\r\n    top: 140px  !important;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
